<template>
  <header :class="{ home: $route.path === '/' }">
    
    <nav class="navbar-contain">
      <ul class="nav-list">
        <div class="nav-left">
          <NavLink
            v-for="link in leftLinks"
            :key="link.text"
            :url="link.url"
            :text="$t('header.title')"
          />
         
        </div>
      

        <!-- Burger menu mobile -->
        <div class="burger" v-if="isMobile" @click="toggleMenu">
          <i :class="menuOpen ? 'fas fa-times' : 'fas fa-bars'"></i>
        </div>

        <!-- Nav droite desktop, masquée mobile quand menu ouvert -->
        <div class="nav-right" v-if="!isMobile">
          
          <li
            class="nav-item dropdown"
            @mouseenter="!isMobile && (dropdownOpen = true)"
            @mouseleave="!isMobile && (dropdownOpen = false)"
          >
            <a
              href="#"
              class="nav-link"
              @click.prevent="isMobile && toggleDropdown()"
            >
              {{ $t('header.abb') }}
              <i
                class="fas fa-chevron-down"
                :class="{ rotated: dropdownOpen }"
              ></i>
            </a>
            <ul class="dropdown-menu" v-show="dropdownOpen">
              <li
                v-for="subLink in maisonSubLinks"
                :key="subLink.text"
                class="dropdown-item"
              >
                <a :href="subLink.url" class="dropdown-link">{{ $t(subLink.text) }} </a>
              </li>
            </ul>
          </li>
          <NavLink
            v-for="link in rightLinks"
            :key="link.text"
            :url="link.url"
            :text="$t(link.text)"
          />
          <LanguageSwitcher />
        </div>
         
      </ul>

 

      <!-- Mobile Menu-->
      <transition name="slide">
  <div v-if="menuOpen && isMobile" class="mobile-menu">
    <div class="close-icon" @click="closeMenu">
    <i class="fas fa-times"></i>
  </div>
   <div class="mobile-header">
  
  <a href="/" class="mobile-title">{{ $t('header.title') }}</a>
   <!-- Ici, juste après le header mobile -->
    <div class="mobile-language">
      <LanguageSwitcher />
    </div>

    
    </div>
    <ul class="mobile-nav-list">
      <li>
        <a href="#" class="mobile-nav-link" @click.prevent="toggleDropdown">
          {{ $t('header.abb') }}
          <i :class="dropdownOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </a>
        <ul v-show="dropdownOpen" class="mobile-dropdown-menu">
          <li v-for="subLink in maisonSubLinks" :key="subLink.text">
            <a :href="subLink.url" class="mobile-dropdown-link">{{ $t(subLink.text) }}</a>
          </li>
        </ul>
      </li>
      <li v-for="link in rightLinks" :key="link.text">
        <a :href="link.url" class="mobile-nav-link">{{ $t(link.text) }}</a>
      </li>
    </ul>
  </div>
   
</transition>

      <!-- Overlay pour fermer menu mobile -->
      <div v-if="menuOpen && isMobile" class="overlay" @click="closeMenu"></div>
    </nav>
  </header>

  <main>
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <BackToTop />
  </main>

  <footer>
    <FooterComponent />
  </footer>
</template>

<script>
import BackToTop from "./components/BackToTop.vue";
import FooterComponent from "./components/FooterComponent.vue";
import NavLink from "./components/NavLink.vue";
import LanguageSwitcher from "./components/LanguageSwitcher.vue";


export default {
  name: "App",
  components: {
    NavLink,
    FooterComponent,
    LanguageSwitcher,
    BackToTop,
  },

  data() {
    return {
      leftLinks: [{ url: "/", text: "header.title" }],
      maisonSubLinks: [
        { url: "/chambres", text: "header.rooms" },
        { url: "/espaces-a-vivre", text: "header.livingSpaces" },
      ],
      rightLinks: [
        { url: "/reservations", text: "header.availability" },
          { url: "/infos-pratiques", text: "header.practical" },
        { url: "/a-propos", text: "header.about" },
      
      ],
      menuOpen: false,
      dropdownOpen: false,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 768;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
      if (!this.isMobile) {
        this.menuOpen = false;
        this.dropdownOpen = false;
      }
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      if (!this.menuOpen) {
        this.dropdownOpen = false;
      }
    },
    closeMenu() {
      this.menuOpen = false;
      this.dropdownOpen = false;
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
  },
};
</script>

<style lang="scss">
@import "./assets/styles/global.scss";

header.home {
  position: absolute;
  color: white;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10; /* pour qu'il soit au-dessus de l'image */
}

.nav-list {
  display: flex;
  list-style: none;
  padding: 0;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.nav-left {
  margin-left: $spacing-large;
  font-size: 25px;
  display: flex;
  align-items: center;
}

.nav-right {
  display: flex;
  gap: 50px;
  margin-right: $spacing-large;
  align-items: center;
}

.navbar-contain {
  background: transparent;
  box-shadow: none;
  border-radius: 0;
  font-size: 20px;
  width: 100%;
  border-bottom: none;
  position: relative;
}

.nav-link i {
  font-size: 0.8rem;
  transition: transform 0.3s ease;
  margin-left: 4px;
}
.nav-item.dropdown:hover i,
.nav-link i.rotated {
  transform: rotate(180deg);
}

.dropdown-menu {
  display: none;
  position: absolute;
  background: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  padding: 0.5rem 0;
  border-radius: 4px;
  top: 100%;
  left: 0;
  min-width: 160px;
  z-index: 100;
}

.nav-item.dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-item {
  padding: 10px 20px;
}

.dropdown-link {
  font-size: $font-size-base;
  text-decoration: none;
  color: #333;
  display: block;
  width: 100%;
  transition: all 0.3s ease;
}

.dropdown-link:hover {
  color: $third-color;
}

/* Burger menu mobile */
.burger {
  font-size: 1.8rem;
  color: #333;
  cursor: pointer;
  margin-right: $spacing-base;
  display: none;
}

/* Mobile drawer */
.mobile-menu {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  width: 100%;
  background: #F5F5F5;
  z-index: 1000;
  padding: 2rem 1.5rem;
  display: flex;
  color:$default-color;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.mobile-header {
  position: relative;
  text-align: center;
  font-size: 1.8rem;
  padding: 1.5rem 1rem 1rem 1rem;
}

.close-icon {
  position: absolute;
  top: 0.5rem;
  right: 2rem;
  font-size: 1.5rem;
  cursor: pointer;
  color: #4F4F4F;
}

.mobile-title {
  margin-top: 0.5rem;
  color: #4F4F4F ;
}


.mobile-nav-list {
  list-style: none;
  padding: 1em;
  margin: 0;
}

.mobile-nav-list > li {
  margin-bottom: 1.5rem;
  padding: 0.5em;

}

.mobile-nav-link {
  font-size: 1.2rem;
  color: #333;
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.mobile-dropdown-menu {
  font-size: 1.2rem;
  margin-top: 0.5rem;
  margin-left: 1rem;
  list-style: none;
  padding-left: 0;
}

.mobile-dropdown-item {
  margin-bottom: 0.7rem;
}

.mobile-dropdown-link {
  color: #333;
  text-decoration: none;

}

.mobile-dropdown-link:hover {
  text-decoration: underline;
}

/* Overlay */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 900;
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}
.slide-enter-to,
.slide-leave-from {
  transform: translateX(0);
}
.mobile-language {
  margin: 1rem 0;
  text-align: center;
}
.mobile-language select {
  padding: 0.3rem;
  font-size: 1rem;
}
/* Responsive */

@media (max-width: 768px) {
  .nav-right {
    display: none !important;
  }
  .burger {
    display: block;
    color: $second-color;
  }
  .nav-list {
    justify-content: space-between;
  }
  .nav-left {
    margin-left: $spacing-min;
  }
  .img-overlay{
    background: none !important;
  }
}
</style>
